import '../../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../../rc-util/es/Dom/dynamicCSS.js';
import 'react';
import '../../../../@ant-design/cssinjs/es/StyleContext.js';
import { unit } from '../../../../@ant-design/cssinjs/es/util/index.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import '../../../../@emotion/unitless/dist/unitless.cjs.js';
import '../../../../stylis/dist/umd/stylis.js';
import '../../../../rc-util/es/warning.js';
import '../../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
import { prepareComponentToken, prepareToken } from './index.js';
import { genSubStyleComponent } from '../../theme/util/genComponentStyleHook.js';
const genBorderedStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
      '&, &:hover': {
        [`${componentCls}-item-link`]: {
          borderColor: token.colorBorder
        }
      },
      '&:focus-visible': {
        [`${componentCls}-item-link`]: {
          borderColor: token.colorBorder
        }
      },
      [`${componentCls}-item, ${componentCls}-item-link`]: {
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        [`&:hover:not(${componentCls}-item-active)`]: {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder,
          a: {
            color: token.colorTextDisabled
          }
        },
        [`&${componentCls}-item-active`]: {
          backgroundColor: token.itemActiveBgDisabled
        }
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        '&:hover button': {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder,
          color: token.colorTextDisabled
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token.colorBgContainerDisabled,
          borderColor: token.colorBorder
        }
      }
    },
    [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        '&:hover button': {
          borderColor: token.colorPrimaryHover,
          backgroundColor: token.itemBg
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token.itemLinkBg,
          borderColor: token.colorBorder
        },
        [`&:hover ${componentCls}-item-link`]: {
          borderColor: token.colorPrimary,
          backgroundColor: token.itemBg,
          color: token.colorPrimary
        },
        [`&${componentCls}-disabled`]: {
          [`${componentCls}-item-link`]: {
            borderColor: token.colorBorder,
            color: token.colorTextDisabled
          }
        }
      },
      [`${componentCls}-item`]: {
        backgroundColor: token.itemBg,
        border: `${unit(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
        [`&:hover:not(${componentCls}-item-active)`]: {
          borderColor: token.colorPrimary,
          backgroundColor: token.itemBg,
          a: {
            color: token.colorPrimary
          }
        },
        '&-active': {
          borderColor: token.colorPrimary
        }
      }
    }
  };
};
var BorderedStyle = genSubStyleComponent(['Pagination', 'bordered'], token => {
  const paginationToken = prepareToken(token);
  return [genBorderedStyle(paginationToken)];
}, prepareComponentToken);
export { BorderedStyle as default };
//# sourceMappingURL=bordered.js.map
